<script setup>
import { onMounted, computed } from 'vue';
import { useStore } from 'vuex';
import { numberWithCommas } from '@/helper';

const store = useStore();
const totalPoints = computed(() => store.getters['rewards/totalPoints']);

onMounted(async () => {
  await store.dispatch('rewards/fetchTotalPoints');
});
</script>

<template>
  <div class="onhover-dropdown">
    <div class="notification-box">
      <router-link :to="{name: 'rewards'}" class="text-decoration-none">
        <div class="point-container">
          <div class="icon-box">
            <i data-v-22be0ec4="" class="vue-feather vue-feather--award icon-white" data-name="award" data-tags="achievement,badge" data-type="award"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-award vue-feather__content"><circle cx="12" cy="8" r="7"></circle><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline></svg></i>
          </div>
          <div class="point-value">
            {{ numberWithCommas(totalPoints) }} PTS
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<style scoped>
.icon-white svg{
  stroke: white !important;
}
.notification-box {
  cursor: pointer;
  display: flex;
  align-items: center;
  height: 100%;
}

.point-container {
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, #7366ff 0%, #a096ff 100%);
  border-radius: 30px;
  padding: 4px 12px 4px 4px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 10px rgba(115, 102, 255, 0.2);
}

.point-container:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 15px rgba(115, 102, 255, 0.3);
}

.icon-box {
  background-color: rgba(255, 255, 255, 0.2);
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.point-value {
  margin-left: 8px;
  font-weight: 600;
  font-size: 12px;
  color: #fff;
  letter-spacing: 0.5px;
}

:deep(.icon-white) {
  stroke: #ffffff !important;
}
</style>